module.exports = __webpack_public_path__ + "assets/add_circle.844496b7.svg";